import { Language, translations, Translations } from "@/lib/translations";
import { useCallback, useState } from "react";

const STORAGE_KEY = "fx-marriel-site-lang";

function isSupportedLanguage(value: string | null): value is Language {
  return value === "en" || value === "pt" || value === "es";
}

function getInitialLanguage(): Language {
  // 1. Check URL override
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get("lang");

  if (isSupportedLanguage(langParam)) {
    localStorage.setItem(STORAGE_KEY, langParam);
    return langParam;
  }

  // 2. Check localStorage
  const stored = localStorage.getItem(STORAGE_KEY);
  if (isSupportedLanguage(stored)) {
    return stored;
  }

  // 3. Browser language detection
  const nav = navigator as Navigator & { userLanguage?: string };
  const browserLang = (nav.language || nav.userLanguage || "en").toLowerCase();

  if (browserLang.startsWith("pt")) {
    return "pt";
  }

  if (browserLang.startsWith("es")) {
    return "es";
  }

  return "en";
}

export function useLanguage() {
  const [language, setLanguageState] = useState<Language>(getInitialLanguage);

  const setLanguage = useCallback((lang: Language) => {
    localStorage.setItem(STORAGE_KEY, lang);
    setLanguageState(lang);
  }, []);

  const t: Translations = translations[language];

  return { language, setLanguage, t };
}
